import React from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'antd'
import { TooltipWrap } from 'pages/Ticket/components/RequestData/styled'
import ArchiveButton from './ArchiveButton'

const TicketStatus = ({
  gutter = 0,
  rowStyle = {},
  isAppointment = false,
  status,
  archiveSpan = 0,
  archiveStyle = {},
  archived,
  archiveItem,
  buttonStyle = {},
  shouldBlockArchiveBtn = false,
  shouldBlockUnarchiveBtn = false,
  option = null
}) => {
  const isArchiveButtonDisabled = archived
    ? shouldBlockUnarchiveBtn
    : shouldBlockArchiveBtn

  const { padding, margin, minwidth } = rowStyle
  const { display, justify } = archiveStyle

  return (
    <Row
      gutter={gutter}
      style={{
        padding,
        margin,
        minWidth: minwidth
      }}
    >
      {status}
      <Col
        span={archiveSpan}
        style={{ display: display ?? '', justifyContent: justify }}
      >
        {isAppointment ? (
          <ArchiveButton
            archived={archived}
            archiveItem={archiveItem}
            isDisabled={isArchiveButtonDisabled}
            buttonStyle={buttonStyle}
          />
        ) : (
          <TooltipWrap>
            <ArchiveButton
              archived={archived}
              archiveItem={archiveItem}
              isDisabled={isArchiveButtonDisabled}
              buttonStyle={buttonStyle}
            />
          </TooltipWrap>
        )}
      </Col>
      {option}
    </Row>
  )
}

TicketStatus.propTypes = {
  gutter: PropTypes.number,
  rowStyle: PropTypes.object,
  isAppointment: PropTypes.bool,
  status: PropTypes.element.isRequired,
  archiveSpan: PropTypes.number,
  archiveStyle: PropTypes.object,
  archived: PropTypes.bool.isRequired,
  archiveItem: PropTypes.func.isRequired,
  buttonStyle: PropTypes.object,
  shouldBlockArchiveBtn: PropTypes.bool,
  shouldBlockUnarchiveBtn: PropTypes.bool,
  option: PropTypes.element
}

export default TicketStatus
